import { Breadcrumbs } from "../../../AbstractElements";
import { Container, Row } from "reactstrap";
import BorderCart from "./BorderCart";
import StyleBorderCart from "./StyleBorderCart";
import BackgroundColorsCart from "./BackgroundColorsCart";
import BorderColorCart from "./BorderColorCart";
import ImagesSizesCart from "./ImagesSizesCart";
import FontStyleCart from "./FontStyleCart";
import FontWeightCart from "./FontWeightCart";
import TextColorsCart from "./TextColorsCart";
import FontSizesCart from "./FontSizesCart";

const HelperClassesContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle="Helper Classes" parent="Ui Kits" title="Helper Classes" />
      <Container fluid>
        <Row>
          <BorderCart />
          <StyleBorderCart />
          <BackgroundColorsCart />
          <BorderColorCart />
          <ImagesSizesCart />
          <FontStyleCart />
          <FontWeightCart />
          <TextColorsCart />
          <FontSizesCart />
        </Row>
      </Container>
    </>
  );
};

export default HelperClassesContainer;
